import type { MessageDescriptor } from "@lingui/core";

/**
 * Lightweight replacement for `@lingui/core/macro`'s `msg` tagged template.
 * Mirrors same-file implementations in other shared constants.
 */
function msg(literals: TemplateStringsArray, ...expressions: unknown[]): MessageDescriptor {
  const message = String.raw(literals, ...expressions);
  return { id: message, message };
}

export interface ListColorItem {
  label: MessageDescriptor;
  name: string;
  hex: string;
}

/**
 * Unified palette of predefined colors for Lists.
 */
export const LIST_COLORS: ListColorItem[] = [
  { label: msg`Gray`, name: "Gray", hex: "#71717a" },
  { label: msg`Red`, name: "Red", hex: "#ef4444" },
  { label: msg`Orange`, name: "Orange", hex: "#f97316" },
  { label: msg`Amber`, name: "Amber", hex: "#f59e0b" },
  { label: msg`Yellow`, name: "Yellow", hex: "#eab308" },
  { label: msg`Lime`, name: "Lime", hex: "#84cc16" },
  { label: msg`Green`, name: "Green", hex: "#22c55e" },
  { label: msg`Emerald`, name: "Emerald", hex: "#10b981" },
  { label: msg`Teal`, name: "Teal", hex: "#14b8a6" },
  { label: msg`Cyan`, name: "Cyan", hex: "#06b6d4" },
  { label: msg`Sky`, name: "Sky", hex: "#0ea5e9" },
  { label: msg`Blue`, name: "Blue", hex: "#3b82f6" },
  { label: msg`Indigo`, name: "Indigo", hex: "#6366f1" },
  { label: msg`Violet`, name: "Violet", hex: "#8b5cf6" },
  { label: msg`Purple`, name: "Purple", hex: "#a855f7" },
  { label: msg`Fuchsia`, name: "Fuchsia", hex: "#d946ef" },
  { label: msg`Pink`, name: "Pink", hex: "#ec4899" },
  { label: msg`Rose`, name: "Rose", hex: "#f43f5e" },
  { label: msg`Brown`, name: "Brown", hex: "#92400e" }, // Retained from native set
  { label: msg`Black`, name: "Black", hex: "#111827" }, // Retained from native set
];

/**
 * Unified list of representative emojis for List icons.
 */
export const LIST_ICONS = [
  "📋",
  "🏠",
  "💼",
  "🎓",
  "🛒",
  "❤️",
  "⭐",
  "🎯",
  "📚",
  "💡",
  "🎵",
  "🏃",
  "🥗",
  "✈️",
  "🎮",
  "🚗",
];

const LIME_INDEX = 5;
export const DEFAULT_LIST_COLOR_HEX = LIST_COLORS[LIME_INDEX]?.hex ?? "#84cc16";
export const DEFAULT_LIST_ICON = "📋";
